import React from "react";
import CenterSpin from "../../misc/spin";
import "./style.css";
import ReactECharts from "echarts-for-react";

/**
 * @param {boolean} isLoading Boolean to set loader circle or graph
 * @param {object} options Echarts options object for graph component
 * @returns Survey card component
 */
export default function CardSurveys({
  isLoading,
  options,
  graphTitle,
  isGraphLeft,
}) {
  return (
    <div className="survey-card-container">
      {graphTitle ? (
        <p
          className={
            "survey-graph-subtitle" +
            (isGraphLeft ? " survey-graph-padding-right" : "")
          }
        >
          {graphTitle}
        </p>
      ) : null}
      <div className="survey-card-graph">
        {isLoading || options === undefined ? (
          <CenterSpin />
        ) : (
          <ReactECharts
            option={options}
            style={{ height: "100%", width: "100%" }}
          />
        )}
      </div>
    </div>
  );
}
